import useDeviceType from "../common/useDeviceType";

const Event = () => {
  const isMobile = useDeviceType();
  return (
    <div
      id="emergency"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      {/* Heading */}
      <div className="text-center">
        <p className="font-medium text-base lg:text-xl">
          많고 많은 하수구 해결 전문 업체들
        </p>
        <h2 className="font-medium">어떤 업체에 문의를 해야할까?</h2>
      </div>

      <div className="relative w-full h-full mx-auto mt-12 grid max-w-screen-lg">
        <div data-aos="fade-up">
          <img
            src={isMobile ? "/images/eventMo1.png" : "/images/eventPc1.png"}
            alt="하수구원킬케어 가격안내"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div data-aos="fade-up" className="-mt-5 cursor-pointer">
          <img
            src={isMobile ? "/images/eventMo2.png" : "/images/eventPc2.png"}
            onClick={() => (window.location.href = "tel:010-8123-8285")}
            alt="하수구원킬케어 가격안내"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
};

export default Event;
